"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = limitsReducer;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = _interopRequireDefault(require("immutable"));

var ActionTypes = _interopRequireWildcard(require("../actions/ActionTypes"));

var _Constants = require("../Constants");

var _Limits = require("../utils/Limits");

var _hubLVideo = require("../utils/hubLVideo");

var _Immutable$Map;

var LimitsDefaultState = _immutable.default.Map((_Immutable$Map = {}, (0, _defineProperty2.default)(_Immutable$Map, _Constants.Limits.EMBEDDABLE_VIDEO, _immutable.default.Map({
  quantityAllowed: 50,
  quantityUsed: 0,
  attemptedVideoUploads: 0
})), (0, _defineProperty2.default)(_Immutable$Map, "requestStatus", _Constants.RequestStatus.UNINITIALIZED), _Immutable$Map));

function limitsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : LimitsDefaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      limits = action.limits,
      uploadingFiles = action.uploadingFiles,
      videoCount = action.videoCount,
      file = action.file;

  switch (type) {
    case ActionTypes.FETCH_LIMITS_SUCCEEDED:
      return state.merge((0, _defineProperty2.default)({
        requestStatus: _Constants.RequestStatus.SUCCEEDED
      }, _Constants.Limits.EMBEDDABLE_VIDEO, _immutable.default.Map({
        quantityAllowed: limits.getIn([_Constants.Limits.EMBEDDABLE_VIDEO, 'quantityAllowed']),
        quantityUsed: limits.getIn([_Constants.Limits.EMBEDDABLE_VIDEO, 'quantityUsed']),
        attemptedVideoUploads: 0
      })));

    case ActionTypes.BULK_UPLOAD_FILES_ATTEMPTED:
      return state.merge((0, _defineProperty2.default)({}, _Constants.Limits.EMBEDDABLE_VIDEO, (0, _Limits.updateAttemptedVideoUploads)(state, (0, _Limits.countUploadingFilesByType)(uploadingFiles, _Constants.FileTypes.MOVIE))));

    case ActionTypes.CONFIRM_VIDEO_UPLOAD_WITHOUT_EMBED:
      return state.merge((0, _defineProperty2.default)({}, _Constants.Limits.EMBEDDABLE_VIDEO, (0, _Limits.updateAttemptedVideoUploads)(state, 0)));

    case ActionTypes.DECREASE_VIDEO_QUANTITY_USED:
      return state.setIn([_Constants.Limits.EMBEDDABLE_VIDEO, 'quantityUsed'], (0, _Limits.getDecreasedQuantityUsed)(state, videoCount));

    case ActionTypes.CREATE_VIDYARD_PLAYERID_SUCCEEDED:
      return state.setIn([_Constants.Limits.EMBEDDABLE_VIDEO, 'quantityUsed'], (0, _Limits.getIncreasedQuantityUsed)(state, 1));

    case ActionTypes.UPLOAD_FILE_SUCCEEDED:
      if ((0, _hubLVideo.isHubLVideo)(file.toJS())) {
        return state.setIn([_Constants.Limits.EMBEDDABLE_VIDEO, 'quantityUsed'], (0, _Limits.getIncreasedQuantityUsed)(state, 1));
      }

      return state;

    case ActionTypes.SOFT_DELETE_VIDYARD_PLAYERID_SUCCEEDED:
      return state.setIn([_Constants.Limits.EMBEDDABLE_VIDEO, 'quantityUsed'], (0, _Limits.getDecreasedQuantityUsed)(state, 1));

    default:
      return state;
  }
}

module.exports = exports.default;